define('modules/form/media_view',[
  'backbone',
  'jquery',
  '_',
  'session',

  './form_item_view',
  'modules/files/file_model',
  'modules/video/player/video_player_view',

  'modules/media_picker/media_picker_view',

  'text!./media_template.html',
  'text!modules/form/media_fact_connection/media_fact_connection_template.html',
], function (
  Backbone,
  $,
  _,
  session,
  FormItemView,
  FileModel,
  VideoPlayer,
  MediaPickerView,
  template,
  media_fact_connection_template
) {
  'use strict';
  var View = FormItemView.extend({
    initialize: function (options) {
      _.extend(this, options);

      this.listenTo(this.model, 'change', this.renderMediaFactConnection);

      FormItemView.prototype.initialize.apply(this, options);

      var value = {};

      value[this.model.get('name')] =
        this.model.get('file_id') || this.model.get('value') || null;
      this.dataModel.set(value);
      this.dataModelAttributesOriginal = _.cloneDeep(this.dataModel.attributes);

      if (
        this.model.get('file_id') &&
        this.model.get('media_type') === 'video'
      ) {
        this.previewVideo();
      }

      this.render();
      this.renderMediaFactConnection();
      this.setupDragEvents();
    },

    template: _.template(template),

    renderMediaFactConnection: function () {
      this.$('.js-media-fact-connection').html(
        this.media_fact_connection_template(this.model.attributes)
      );
      return this;
    },

    render: function () {
      var json = this.model.toJSON();
      json.cid = this.model.cid;
      this.$el.html(this.template(json));
      return this;
    },

    media_fact_connection_template: _.template(media_fact_connection_template),

    events: {
      'change [type=file]': 'handleInput',
      'click .video-poster': 'viewVideo',
      'click .js-pick-media': 'showMediaPicker',
      'click .js-open-kdam': 'showKDAM',
      'click .js-remove-media': 'removeMedia',
    },

    setupDragEvents: function () {
      var self = this;
      $('body').on(
        'drag dragstart dragend dragover dragenter dragleave drop',
        function (e) {
          e.preventDefault();
          e.stopPropagation();
        }
      );

      this.$('.media-field')

        .on('dragover dragenter', function (e) {
          var target = e.currentTarget;
          target.classList.add('is-dragover');
        })

        .on('dragleave dragend drop', function (e) {
          var target = e.currentTarget;
          target.classList.remove('is-dragover');
        })

        .on('drop', function (e) {
          var files = e.originalEvent.dataTransfer.files;
          if (files[0].type.match('image.*')) {
            self.processImage(files[0]);
          }
          if (files[0].type.match('video.*')) {
            self.processVideo(files[0]);
          }
        });
    },

    handleInput: function (e) {
      var file = e.originalEvent.target.files[0];

      if (file.type.match('image.*')) {
        this.processImage(file);
      }
      if (file.type.match('video.*')) {
        this.processVideo(file);
      }

      e.originalEvent.target.value = '';
    },

    processImage: function (image, isKDAM) {
      // Task #9237 - Check for multiple "." in file name
      if (image.name.match(/\./g).length > 1) {
        Backbone.trigger('showError', 'fileUploadError', null);
        return;
      }
      var self = this;
      var reader = new FileReader();
      reader.onload = function (img) {
        var thumbnail =
          '<img class="thumbnail" src="' + img.target.result + '">';
        self.$('.media-preview').html(thumbnail);
        self.$('.form-field').addClass('has-media is-uploading');
      };

      reader.readAsDataURL(image);
      this.uploadImage(image, isKDAM);
    },

    uploadImage: function (image, isKDAM) {
      var self = this;
      var hasPreUploadedMedia = this.$('.form-field').hasClass('has-media');
      // TODO: change url and add some better feedback
      if (this.model.get('upload_url')) {
        if (isKDAM !== true) {
          isKDAM = false;
        }
        this.url =
          session.get('apiBaseUrl') +
          this.model.get('upload_url') +
          '?isKdam=' +
          isKDAM;
      } else {
        this.url = session.get('apiUrl') + 'comments/files';
      }
      var formdata = new FormData();
      formdata.append(image.name, image);
      var xhr = new XMLHttpRequest();
      xhr.withCredentials = true;
      xhr.open('POST', this.url, true);

      xhr.addEventListener('load', function (e) {
        self.$('.form-field').removeClass('is-uploading');
        var response = JSON.parse(xhr.responseText);
        if (response.success) {
          var property = self.model.get('name');

          self.dataModel.set(property, response.id);

          if (self.model.get('media_fact_connection') === 'Connected') {
            self.model.set('media_fact_connection', 'WillDisconnect');
          }
          // Reset to 'Connected' if user changes back to the original value.
          else if (
            self.model.get('media_fact_connection') === 'WillDisconnect' &&
            response.id === self.dataModelAttributesOriginal[property]
          ) {
            self.model.set('media_fact_connection', 'Connected');
          }
        } else {
          if (!hasPreUploadedMedia) {
            self.$('.media-preview').html('');
            self.$('.form-field').removeClass('has-media');
          }
          var message = response.Message || null;
          Backbone.trigger('showError', 'fileUploadError', message);
        }
      });

      xhr.send(formdata);
    },

    processVideo: function (video, isKDAM) {
      // Task #9237 - Check for multiple "." in file name
      if (video.name.match(/\./g).length > 1) {
        Backbone.trigger('showError', 'fileUploadError', null);
        return;
      }
      var self = this;
      var reader = new FileReader();
      reader.onload = function (mov) {
        var thumbnail =
          '<video class="thumbnail" autoplay src="' + mov.target.result + '">';
        self.$('.video-preview').html(thumbnail);
        self.$('.form-field').addClass('has-media is-uploading');
      };

      reader.readAsDataURL(video);
      this.uploadVideo(video, isKDAM);
    },

    uploadVideo: function (image, isKDAM) {
      var self = this;
      var hasPreUploadedMedia = this.$('.form-field').hasClass('has-media');

      // TODO: change url and add some better feedback
      if (this.model.get('upload_url')) {
        if (isKDAM !== true) {
          isKDAM = false;
        }
        this.url =
          session.get('apiBaseUrl') +
          this.model.get('upload_url') +
          '?isKdam=' +
          isKDAM;
      } else {
        this.url = session.get('apiUrl') + 'comments/files';
      }

      var formdata = new FormData();
      formdata.append(image.name, image);
      var xhr = new XMLHttpRequest();
      xhr.withCredentials = true;
      xhr.open('POST', this.url, true);
      xhr.addEventListener('progress', function (evt) {
        if (evt.lengthComputable) {
          var percentComplete = evt.loaded / evt.total;
          //Do something with download progress
          console.log(percentComplete);
        }
      });

      xhr.addEventListener('load', function (e) {
        self.$('.form-field').removeClass('is-uploading');

        var response = JSON.parse(xhr.responseText);
        if (response.success) {
          var property = self.model.get('name');

          self.dataModel.set(property, response.id);

          if (self.model.get('media_fact_connection') === 'Connected') {
            self.model.set('media_fact_connection', 'WillDisconnect');
          }
          // Reset to 'Connected' if user changes back to the original value.
          else if (
            self.model.get('media_fact_connection') === 'WillDisconnect' &&
            response.id === self.dataModelAttributesOriginal[property]
          ) {
            self.model.set('media_fact_connection', 'Connected');
          }

          self.previewVideo();
        } else {
          if (!hasPreUploadedMedia) {
            self.$('.media-preview').html('');
            self.$('.form-field').removeClass('has-media');
          }
          var message = response.Message || null;
          Backbone.trigger('showError', 'fileUploadError', message);
        }
      });

      xhr.send(formdata);
    },

    previewVideo: function () {
      this.fileModel = new FileModel({
        id: this.dataModel.get(this.model.get('name')),
      });
      this.listenTo(
        this.fileModel,
        'sync',
        function () {
          this.renderPosters();
        },
        this
      );
      this.fileModel.fetch();
    },

    renderPosters: function () {
      this.$('.media-preview').html(
        '<img class="video-poster" src="' +
          _.media_url(this.fileModel.get('poster')) +
          '" />'
      );
    },

    viewVideo: function (e) {
      e.preventDefault();
      var video = new VideoPlayer({ model: this.fileModel });
      this.$('.media-preview').html(video.$el);
    },

    removeMedia: function (e) {
      e.preventDefault();

      var property = this.model.get('name');

      this.dataModel.set(property, null);

      if (this.model.get('media_fact_connection') === 'Connected') {
        this.model.set('media_fact_connection', 'WillDisconnect');
      }
      // Reset to 'Connected' if user changes back to the original value.
      else if (
        this.model.get('media_fact_connection') === 'WillDisconnect' &&
        null == this.dataModelAttributesOriginal[property]
      ) {
        this.model.set('media_fact_connection', 'Connected');
      }

      this.$('.media-preview').html('');
      this.$('.form-field').removeClass('has-media');
    },

    showMediaPicker: function () {
      var mediaPicker,
        pickFile = function (file) {
          var format = 'image',
            mediaId = false;

          if (file.has('metadata')) {
            format = file.get('metadata').format;
          }

          if (file.get('media_id')) {
            mediaId = file.get('media_id');
          } else if (file.get('id')) {
            mediaId = file.get('id');
          }

          if (mediaId) {
            var property = this.model.get('name');

            this.dataModel.set(property, mediaId);

            if (this.model.get('media_fact_connection') === 'Connected') {
              this.model.set('media_fact_connection', 'WillDisconnect');
            }
            // Reset to 'Connected' if user changes back to the original value.
            else if (
              this.model.get('media_fact_connection') === 'WillDisconnect' &&
              mediaId === this.dataModelAttributesOriginal[property]
            ) {
              this.model.set('media_fact_connection', 'Connected');
            }

            var thumbnail =
              '<img class="thumbnail" src="' +
              _.media_url(file.get('thumbnail')) +
              '">';
            this.$('.media-preview').html(thumbnail);
            this.$('.form-field').addClass('has-media');
          }

          mediaPicker.modal.close();
        }.bind(this);

      mediaPicker = new MediaPickerView({
        limit: 60,
        onSelect: pickFile,
      });
    },

    getImageBlob: function (url, callback) {
      var img = new Image();
      img.setAttribute('crossOrigin', 'anonymous');
      img.onload = function (a) {
        var canvas = document.createElement('canvas');
        canvas.width = this.width;
        canvas.height = this.height;
        var ctx = canvas.getContext('2d');
        ctx.drawImage(this, 0, 0);

        var dataURI = canvas.toDataURL('image/jpg');

        // convert base64/URLEncoded data component to raw binary data held in a string
        var byteString;
        if (dataURI.split(',')[0].indexOf('base64') >= 0) {
          byteString = atob(dataURI.split(',')[1]);
        } else {
          byteString = unescape(dataURI.split(',')[1]);
        }

        // separate out the mime component
        var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

        // write the bytes of the string to a typed array
        var ia = new Uint8Array(byteString.length);
        for (var i = 0; i < byteString.length; i++) {
          ia[i] = byteString.charCodeAt(i);
        }

        return callback(new Blob([ia], { type: mimeString }));
      };

      img.src = url;
    },

    getVideoBlob: function (url, callback) {
      var request = new XMLHttpRequest();
      request.open('GET', url, true);
      request.responseType = 'blob';
      request.onload = function () {
        return callback(request.response);
      };
      request.send();
    },

    showKDAM: function () {
      var self = this;
      BynderCompactView.open({
        onSuccess: function (assets) {
          if (assets[0].type.toLowerCase() === 'image') {
            self.getImageBlob(
              assets[0].derivatives.webImage,
              function (blobImage) {
                var fileName = assets[0].name.includes('.')
                  ? assets[0].name
                  : assets[0].name + '.png';
                var fileObject = new File([blobImage], fileName, {
                  type: 'image',
                });
                self.processImage(fileObject, true);
              }
            );
          } else if (assets[0].type.toLowerCase() === 'video') {
            self.getVideoBlob(assets[0].previewUrls[0], function (blob) {
              var fileObject = new File([blob], assets[0].name + '.mp4', {
                type: 'video/mp4',
              });
              self.processVideo(fileObject, true);
            });
          }
        },
        portal: {
          url: 'kdam.kesko.fi',
        },
        mode: 'SingleSelect',
        assetTypes: ['image', 'video'],
        /* ... other options ... */
      });
    },
  });
  return View;
});

